import { useEffect } from "react";

interface UseDocumentMetaProps {
  title?: string;
  description?: string;
  lang?: string;
}

/**
 * Sets document title, meta description, and html lang attribute.
 * No external dependencies required - uses standard DOM APIs.
 */
export function useDocumentMeta({
  title,
  description,
  lang,
}: UseDocumentMetaProps) {
  useEffect(() => {
    if (title) {
      document.title = title;
    }
  }, [title]);

  useEffect(() => {
    if (description) {
      let metaDesc = document.querySelector('meta[name="description"]');
      if (!metaDesc) {
        metaDesc = document.createElement("meta");
        metaDesc.setAttribute("name", "description");
        document.head.appendChild(metaDesc);
      }
      metaDesc.setAttribute("content", description);
    }
  }, [description]);

  useEffect(() => {
    if (lang) {
      document.documentElement.lang = lang;
    }
  }, [lang]);
}
